import { CrudSorting } from '@refinedev/core';

export const generateSort = <T extends string | number | boolean>(
  sorters?: CrudSorting,
): Record<string, T> | undefined => {
  if (sorters && sorters.length > 0) {
    const sortObj: Record<string, T> = {};
    sorters.forEach((sort) => {
      sortObj[sort.field] = sort.order as T;
    });
    return sortObj;
  }
  return undefined;
};

export default generateSort;
